import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide12Klarstellung(_: SlideProps) {
  return (
    <div className="deck-root dark slide-manifesto" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 360,
          height: 360,
          top: "-100px",
          left: "-100px",
          background: "var(--svo-blau)",
          opacity: 0.25,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 280,
          height: 280,
          bottom: "-80px",
          right: "5%",
          background: "var(--svo-gruen)",
          opacity: 0.12,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head" style={{ textAlign: "center", margin: "0 auto" }}>
        <div className="deck-eyebrow rise rise-1">Klarstellung</div>
      </header>

      <div className="deck-lead" style={{ margin: "0 auto", textAlign: "center" }}>
        <div className="lead-statement rise rise-3">
          Die KI sortiert, der Chatbot beantwortet Standardfragen –{" "}
          <span className="accent">die komplexen Fälle brauchen euch.</span>
        </div>
      </div>
    </div>
  );
}
